// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.edge",
    name: "Edge Wallet",
    homepage: "https://edge.app/",
    image_id: "f601bc29-4298-422f-dbf7-34dac2884f00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/edge-bitcoin-wallet/id1344400091",
        android: "https://play.google.com/store/apps/details?id=co.edgesecure.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "edge://",
        universal: "https://deep.edge.app/wc",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map